import { render, staticRenderFns } from "./AdminContentItemFinancialTable.vue?vue&type=template&id=24face42&"
import script from "./AdminContentItemFinancialTable.vue?vue&type=script&lang=ts&"
export * from "./AdminContentItemFinancialTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports